import { ReactComponent as WarningIconSVG } from '@/assets/icons/WarningIcon.svg';
import { SVGProps } from 'react';

const WarningIcon = (props: SVGProps<SVGSVGElement>) => <WarningIconSVG {...props} />;

export default WarningIcon;
